import { useSrpContext } from '@/src/contexts'
import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

const SEOFilterHeader = () => {
    const tHeader = useTranslations('header')
    const tCommon = useTranslations('common')
    const {
        SEOSrpData: { card: cards }
    } = useSrpContext()
    const totalFlights = cards?.length || 0
    return (
        <Box
            sx={{
                px: 2,
                py: 1.5,
                borderBottom: 1,
                borderColor: 'grey.200',
                bgcolor: 'background.default',
                position: 'sticky',
                top: 0,
                zIndex: 1
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="body2" sx={{ color: 'grey.600' }}>
                    <Typography component="span" sx={{ fontWeight: 600, color: 'grey.900' }}>
                        {totalFlights}
                    </Typography>
                    <Typography component="span" sx={{ color: 'grey.500', mx: 0.5 }}>
                        {tCommon('of')}
                    </Typography>
                    <Typography component="span" sx={{ fontWeight: 600, color: 'grey.900' }}>
                        {totalFlights}
                    </Typography>
                    <Typography component="span" sx={{ color: 'grey.500', mx: 0.5 }}>
                        {tHeader('flights')}
                    </Typography>
                </Typography>
            </Box>
        </Box>
    )
}

export default SEOFilterHeader
